const BrandLogo = () => (
  <svg aria-hidden="true" className="brand-logo" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="14" fill="url(#brand-gradient)" />
    <rect x="12" y="10" width="24" height="28" rx="5" stroke="white" strokeWidth="2.5" />
    <path d="M17 29.5L21.5 24.5L25 28L28.5 21.5L32 29.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="29.5" cy="17.5" r="2.5" fill="white" />
    <defs><linearGradient id="brand-gradient" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse"><stop stopColor="#5B5CE2" /><stop offset="1" stopColor="#A855F7" /></linearGradient></defs>
  </svg>
);

export default BrandLogo;
